import useTracker from '@/hooks/useTracker';
import { CLICK_AMEND_ORDER, CLICK_AMEND_ORDER_CONFIRM } from '@services/trackerConst';

import { useStockBuySellContext } from '../StockBuySell/hooks';
import { getAtoDuration, getAtoTriggerPrice } from '../tracker/helpers';

const useEventTracker = ({ orderDetail } = {}) => {
  const { trackEvent } = useTracker();

  const { code, formState, formKey, isLimitOrder, isAutoOrder, maxBuy, maxSell } =
    useStockBuySellContext();

  /* Get data from API response */
  const orderDetailProps = {
    stock: orderDetail?.code,
    order_side: orderDetail?.order_side,
    account_type: orderDetail?.account_type,
    order_type: orderDetail?.order_type,
    period: orderDetail?.order_period,
    price: orderDetail?.price,
    lot: orderDetail?.lot_count,
    total: orderDetail?.total,
  };

  /* Get data from form context */
  const formProps = {
    stock: code,
    order_side: formState?.[formKey.INPUT_ORDER_SIDE],
    account_type: formState?.[formKey.INPUT_ACCOUNT_TYPE]?.label,
    order_type: formState?.[formKey.TAB_ORDER_TYPE]?.key,
    price: formState?.[formKey.INPUT_PRICE],
    lot: formState?.[formKey.INPUT_LOT_COUNT],
    total: formState?.[formKey.CALC_ORDER_TOTAL],
    buying_power: maxBuy?.label,
    available_lot: maxSell?.label,
    ...(isLimitOrder
      ? {
          period: formState?.[formKey.INPUT_ORDER_PERIOD]?.value,
        }
      : {}),
    ...(isAutoOrder
      ? {
          ato_start: formState[formKey.INPUT_START_DATE],
          ato_end: formState[formKey.INPUT_END_DATE],
          ato_duration: getAtoDuration(formState),
          ato_trigger_price: getAtoTriggerPrice(formState),
        }
      : {}),
  };

  const eventShowPopupAmend = () => {
    trackEvent(CLICK_AMEND_ORDER, orderDetailProps);
  };

  const eventClickConfirmAmend = () => {
    trackEvent(CLICK_AMEND_ORDER_CONFIRM, formProps);
  };

  return {
    eventShowPopupAmend,
    eventClickConfirmAmend,
  };
};

export default useEventTracker;
